import { useQueryClient } from "@tanstack/react-query";
import { signOut } from "next-auth/react";

export default function useSignOut() {
  const queryClient = useQueryClient();

  return async (callbackUrl = "/sign-in") => {
    queryClient.clear();
    await signOut({ callbackUrl });
  };
}
